module.exports = __webpack_public_path__ + "static/media/postres.03b4ce8f.svg";